import React from 'react';
import cx from 'classnames';
import { string, func, bool } from 'prop-types';
import IconButton from 'components/IconButton';
import CloseIcon from 'icons/close.inline.svg';
import PlusIcon from 'icons/plus.inline.svg';
import ChevronIcon from 'icons/chevron.inline.svg';

import styles from './Footer.scss';

export default function Footer({
  className,
  onCancel,
  onDone,
  onNew,
  onClose,
  isFinalStep,
  isFinished,
  createNewLabel,
  waitForResponse,
}) {
  if (!isFinished) {
    return (
      <div className={cx(styles.main, className)}>
        <IconButton onClick={onCancel} label="cancel" disabled={waitForResponse} isSecondary>
          <CloseIcon className={styles.icon} />
        </IconButton>
        <IconButton
          onClick={onDone}
          label="done"
          disabled={!isFinalStep || waitForResponse}
          iconRight
        >
          <ChevronIcon />
        </IconButton>
      </div>
    );
  }
  return (
    <div className={cx(styles.main, className)}>
      <IconButton onClick={onClose} label="close" isSecondary>
        <CloseIcon />
      </IconButton>
      <IconButton onClick={onNew} label={createNewLabel}>
        <PlusIcon />
      </IconButton>
    </div>
  );
}

Footer.propTypes = {
  onCancel: func.isRequired,
  onDone: func.isRequired,
  onNew: func.isRequired,
  onClose: func.isRequired,
  isFinalStep: bool.isRequired,
  isFinished: bool.isRequired,
  createNewLabel: string.isRequired,
  className: string,
  waitForResponse: bool,
};

Footer.defaultProps = {
  createNewLabel: 'create new',
};



// WEBPACK FOOTER //
// ./src/components/MapPanel/Footer/index.js